<template>
    <div>
        <app-tabela
            idTabela="tblSeguros"
            :itens="contrato.segurosGarantias"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-inserir
                        :contrato="contrato"
                        @obterSegurosAtualizados="obterSeguros()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="valor" slot-scope="data">
                <span>
                    {{ data.valor | currency }}
                </span>
            </template>
            <template slot="tipoSeguroGarantiaContrato" slot-scope="data">
                <span>
                    {{ data.tipoSeguroGarantiaContrato == 0 ?  'SEGURO' : 'GARANTIA' }}
                </span>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar
                    :contrato="contrato"
                    :seguro="data"
                    @obterSegurosAtualizados="obterSeguros()"
                ></btn-atualizar>
                <btn-excluir
                    :seguro="data"
                    @obterSegurosAtualizados="obterSeguros()"
                ></btn-excluir>

                <btn-download
                    v-if="!(data.documentoComprobatorio == null || data.documentoComprobatorio === '')"
                    :seguro="data"
                ></btn-download>


            </template>
        </app-tabela>
    </div>
</template>

<script>
import SegurosServicos from './SegurosServicos'
import BtnInserir from './BtnInserirSeguros'
import BtnAtualizar from './BtnAtualizarSeguros'
import BtnExcluir from './BtnExcluirSeguros'
import BtnDownload from './BtnDownloadSeguros'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        BtnDownload,
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            itensProcessos: [],
            campos: [
                {
                    key: 'tipoSeguroGarantiaContrato',
                    label: 'Tipo',
                    sortable: true,
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'numeroApolice',
                    label: 'Número da Apólice',
                    sortable: true,
                },
                {
                    key: 'dataVencimento',
                    label: 'Vencimento',
                    sortable: true,
                    type: 'date',
                },
                {
                    key: 'documentoComprobatorio',
                    label: 'Nome do Documento',
                    sortable: true,
                },
                {
                    key: 'dataDoAvisoDeVencimento',
                    label: 'Data do Aviso de Vencimento',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterSeguros() {
            this.$store.dispatch('addRequest')
            SegurosServicos.obterSeguros(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarSeguros', response.data)
                        this.$emit('atualizarEngenharia')
                    } else {
                        this.$toast.error(
                            'Erro ao obter as manutenções',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {}
}
</script>
